import React, { useState } from 'react'
import { BLACK, GREY, Icons } from '@doseme/cohesive-ui'

import { TProps } from './types'
import {
  REPORTS_DRUG_MODEL_ACCESS_URL,
  REPORTS_SUBSCRIPTION_EXPIRY_ACCESS_URL
} from '../../../../constants/urls/frontend'

import './index.scss'

const Display: React.FC<TProps> = (props: TProps): JSX.Element => {
  const { history } = props

  const [drugModelAccess, setDrugModelAccess] = useState<boolean>(false)
  const [subscriptionExpiry, setSubscriptionExpiry] = useState<boolean>(false)

  const handleLink = (url: string) => {
    history.push(url)
  }

  return (
    <div className='co-reports-page'>
      <div className='reports-page-title'>Reports</div>
      <div className='d-flex'>
        <div className='d-flex'>
          <div
            data-testid='reports-access'
            className='reports-panel'
            onClick={() => handleLink(REPORTS_DRUG_MODEL_ACCESS_URL)}
            onMouseLeave={() => setDrugModelAccess(false)}
            onMouseOver={() => setDrugModelAccess(true)}
          >
            <div className='reports-panel-title drug-model-access'>Drug model access</div>
            <div className='reports-panel-text'>
              Generate a list of hospitals with access to the selected drug model
            </div>

            <div data-testid='drug-model-access-icon' className='reports-arrow-link'>
              <Icons.BackArrowRounded fill={drugModelAccess ? BLACK : GREY} />
            </div>
          </div>
        </div>
        <div className='d-flex ml-4'>
          <div
            data-testid='reports-access'
            className='reports-panel'
            onClick={() => handleLink(REPORTS_SUBSCRIPTION_EXPIRY_ACCESS_URL)}
            onMouseLeave={() => setSubscriptionExpiry(false)}
            onMouseOver={() => setSubscriptionExpiry(true)}
          >
            <div className='reports-panel-title subscription-expiry'>Subscription Expiry</div>
            <div className='reports-panel-text'>
              Generate a list of hospitals with subscriptions set to expire during the defined date range
            </div>

            <div data-testid='drug-model-access-icon' className='reports-arrow-link'>
              <Icons.BackArrowRounded fill={subscriptionExpiry ? BLACK : GREY} />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export { Display }
